import Vue from 'vue'
import {TranslationPlugin} from '@pitcher/vue-sdk/src/i18n/i18n'

Vue.use(TranslationPlugin, {
  availableLanguages: JSON.parse(process.env.VUE_APP_LANGUAGES)
})
